import MainLayoutView from './MainLayout.view';
export default MainLayoutView;
